import { getKPIBasedOnMatchedProperty, getPropertyValueOrDefault } from '../../../../../utils/generalUtilities';
import { SECTION_DATA_TYPE, SECTION_TYPES } from '../tabs/utils/utils';

const get = state => state.bptPreferenceAnalysis;
export const getBptPreferenceAnalysisDataSelector = state => get(state);
export const getBptPreferenceAnalysisAdRecallDataSelector = state => get(state).adRecallData;
export const getBptPreferenceAnalysisAwarenessDataSelector = state => get(state).awarenessData;
export const getBptPreferenceAnalysisConsiderationSelector = state => get(state).considerationData;
export const getBptPreferenceAnalysisImageDataSelector = state => get(state).imageData;
export const getBptPreferenceAnalysisValueForMoneySelector = state => get(state).valueForMoneyData;
export const getBptPreferenceAnalysisContentScopeSelector = state => get(state).contentScope;
export const getBptPreferenceAnalysisCheckedEvolutionBrands = state => get(state).checkedEvolutionBrands;
//evolution report brands selectors
export const getBPTAwarenessEvolutionBrandsSelector = state => get(state).awarenessData?.brands;
export const getBPTConsiderationEvolutionBrandsSelector = state => get(state).considerationData?.brands;
export const getBPTImageEvolutionBrandsSelector = state => get(state).imageData?.brands;
//evolution report enable property
export const getBPTAwarenessEvolutionIsEnabledSelector = state => get(state).awarenessData?.isEvolutionEnabled;
export const getBPTConsiderationEvolutionIsEnabledSelector = state => get(state).considerationData?.isEvolutionEnabled;
export const getBPTImageEvolutionIsEnabledSelector = state => get(state).imageData?.isEvolutionEnabled;

export const getBptPreferenceAnalysisTableSectionSelector = state => {
    const imageData = getPropertyValueOrDefault(get(state).imageData, SECTION_DATA_TYPE.DEFAULT, null);
    const sectionWithTableData = getKPIBasedOnMatchedProperty(imageData, 'sectionType', SECTION_TYPES.TABLE);

    return sectionWithTableData;
};
